module.exports = __webpack_public_path__ + "static/CareLabel-v2-no-border-3d4d6b1c4fe48aa3bc4bd9d1e0e5b4c0.svg";